export enum RightsEnum {
    ViewRight = "viewRight",
    UpdateRight = "updateRight",
    DeleteRight = "deleteRight",
}